import { ICommissionType, IRegisteredUser } from "../models/epcCustomer.model";
import ResponseModel from "../models/response.model";
import axiosSetup from "../utils/axiosSetup";

export const fetchEpcs = async () => {
  try {
    const { data } = await axiosSetup.get("Epc/getAll");
    return data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const addEpc = async (epcData: any) => {
  try {
    const response = await axiosSetup.post(`Epc/AddEpc`, epcData);
    return response.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message || "Failed to add EPC");
  }
};
export const addEpcOrder = async (
  customerId: string,
  name: string,
  email: string,
  mobileNumber: string,
  billingAddress: string,
  shippingAddress: string,
  category: string,
  gstin: string,
  goods: any,
  quotationId?: string,
  transportPrice?: number,
) => {
  try {
    const response = await axiosSetup.post(`Epc/addEpcOrder/${customerId}`, {
      name,
      email,
      mobileNumber,
      billingAddress,
      shippingAddress,
      category,
      gstin,
      goods, // ✅ Send `goods` instead of `quotation`
      quotationId,
      transportPrice,
    });
    return response.data.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message || "Failed to add EPC");
  }
};

// This all are api is for whatsapp chatbot
export const fetchAllEpcPayments = async (
  page: number,
  limit: number,
  paymentStatus?: string,
  searchQuery?: string,
) => {
  try {
    const response = await axiosSetup.get("Epc/get-all-epc-payments", {
      params: {
        searchQuery,
        page,
        limit,
        paymentStatus,
      },
    });
    return response.data as ResponseModel;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const getStatusHistoryApi = async (id: string) => {
  try {
    const response = await axiosSetup.get(`Epc/get-status-history/${id}`);
    return response.data as ResponseModel;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const updateQuoteStatusApi = async (
  quoteId: string,
  statusKey: string,
  remark?: string,
  loanDetails?: {
    bankName: String;
    dateApplied: Date;
    approvedDate?: Date;
    rejectedDate?: Date;
    approvalLetter?: String;
    isJansmarath?: boolean;
  },
) => {
  try {
    const response = await axiosSetup.post(
      "Epc/update-quote-status",
      { statusKey, remark, loanDetails },
      {
        params: {
          quoteId,
        },
      },
    );
    return response.data as ResponseModel;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};
export const fetchRegisteredUserInfo = async () => {
  try {
    const response = await axiosSetup.get("Epc/getRegisteredUserInfo");
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const getAllDetailsOfRegisteredCustomer = async (
  salesRepId?: string,
  status?: string,
  cseID?: string,
  search?: string,
  page: number = 1,
  startDate?: string,
  endDate?: string,
  panelBrand?: string,
  plantSize?: string,
  registrationStatus?: string,
): Promise<ResponseModel> => {
  try {
    const params: any = { page };
    if (search) params.search = search;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (panelBrand) params.panelBrand = panelBrand;
    if (plantSize) params.plantSize = plantSize;
    if (registrationStatus) params.registrationStatus = registrationStatus;
    if (status) params.statusKey = status;
    const body: any = {};
    if (salesRepId) body.salesRepId = salesRepId;
    if (cseID) body.cseID = cseID;

    const response = await axiosSetup.post(
      "Epc/getAllDetailsOfRegisteredCustomer",
      body,
      { params },
    );
    return response.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Something went wrong";
  }
};

export const getPaymentDetails = async (customerMobile: string) => {
  try {
    const response = await axiosSetup.post(`Epc/getPaymentsByCustomerMobile/`, {
      customerMobile,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const registerUser = async (customerData: IRegisteredUser) => {
  try {
    const response = await axiosSetup.post("Epc/addNewCustomer", customerData);
    return response.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};
export const deleteUser = async (customerId: string) => {
  try {
    const response = await axiosSetup.delete(
      `Epc/delete-customer/${customerId}`,
    );
    return response.data as ResponseModel;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

// Payment Approve and reject
export const approvePayment = async (paymentId: string) => {
  try {
    const response = await axiosSetup.post(`Epc/approvePayment/`, {
      paymentId,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const rejectPayment = async (paymentId: string) => {
  try {
    const response = await axiosSetup.post(`Epc/rejectPayment/`, {
      paymentId,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};
export const getAllQuotes = async (
  search?: string,
  page: number = 1,
  panelBrand?: string,
  plantSize?: string,
  isConfirmed?: boolean,
  panelType?: string,
  salesRepId?: string,
  startDate?: string,
  endDate?: string,
) => {
  try {
    const params: any = { page };
    if (search) params.search = search;
    if (panelBrand) params.panelBrand = panelBrand;
    if (plantSize) params.plantSize = plantSize;
    if (isConfirmed !== undefined) params.isConfirmed = isConfirmed;
    if (panelType) params.panelType = panelType;
    if (salesRepId) params.salesRepId = salesRepId;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await axiosSetup.get("Epc/getAllQuotes", {
      params,
    });

    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to fetch quotes";
  }
};

export const createQuoteApi = async (
  customerName: string,
  mobileNumber: any,
  subsidyAmount: number,
  brand: string,
  panelType: string,
  plantSize: string,
  plantCost: number,
  meterCost: number,
  salesRepresentative?: string,
  cseID?: string,
) => {
  try {
    const response = await axiosSetup.post("Epc/createQuote", {
      customerName,
      mobileNumber,
      salesRepresentative,
      subsidyAmount,
      brand,
      panelType,
      plantSize,
      plantCost,
      meterCost,
      cseID,
      isWeb: true,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data || err;
  }
};

export const confirmQuoteApi = async (
  quoteId: string,
  customCommission?: number,
  customCommissionType?: ICommissionType,
  excessAmount?: number,
) => {
  try {
    const response = await axiosSetup.patch(`Epc/confirmQuote/`, {
      id: quoteId,
      customCommission,
      customCommissionType,
      excessAmount,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const activateQuoteApi = async (
  quoteId: string,
): Promise<ResponseModel> => {
  try {
    const response = await axiosSetup.patch(`Epc/activateQuote/${quoteId}`);
    return response.data as ResponseModel;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const openQuoteApi = async (id: any) => {
  try {
    const response = await axiosSetup.post(
      "Epc/openQuotePDF",
      { id },
      {
        responseType: "blob",
      },
    );

    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);

    window.open(pdfUrl, "_blank");

    return pdfUrl;
  } catch (err: any) {
    console.error("Error opening quotation PDF:", err);
    throw err.response?.data?.message || "Failed to open quotation PDF";
  }
};

export const getEpcMetaDataApi = async () => {
  try {
    const response = await axiosSetup.get("Epc/getEpcMetaData");
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};
export const approveNetMeterCostPaymentApi = async (customerId: string) => {
  try {
    const response = await axiosSetup.patch(`Epc/approveNetMeterCostPayment`, {
      customerId,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const updateRegisteredCustomerApi = async (
  customerId: string,
  customerName: string,
  mobileNumber: string,
  email: string,
  cseId?: string,
  salesRepId?: string,
) => {
  try {
    const response = await axiosSetup.patch(`Epc/updateCustomer`, {
      customerId,
      customerName,
      mobileNumber,
      email,
      cseId,
      salesRepId,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const getCustomerQuotesApi = async (mobileNumber: string) => {
  try {
    const response = await axiosSetup.post(`Epc/getCustomerQuotes`, {
      mobileNumber,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const getAllEpcNamesIdsApi = async () => {
  try {
    const res = await axiosSetup.get("/Epc/getAllEpcNamesIds");
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateQuoteDiscountApi = async (
  quoteId: string,
  discount: number,
) => {
  try {
    const response = await axiosSetup.patch("/Epc/update-quote-discount", {
      quoteId,
      discount,
    });
    return response.data.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message || "Failed to update discount");
  }
};

export const uploadCustomerDocumentApi = async (formData: FormData) => {
  try {
    const response = await axiosSetup.post(
      "Epc/upload-kyc-document",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message || "Failed to upload document");
  }
};

export const addRepaymentTaskApi = async (
  mobileNumber: string,
  customerName: string,
  totalCost: number,
  quotationId: string,
) => {
  try {
    const response = await axiosSetup.post("Epc/add-repayment-task", {
      mobileNumber,
      customerName,
      totalCost,
      quotationId,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};
export const updateProductRegistrationApi = async (
  customerId: string,
  formData: FormData,
) => {
  try {
    const response = await axiosSetup.patch(
      `Epc/update-product-form/${customerId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return response.data.data;
  } catch (err: any) {
    throw new Error(
      err.response?.data?.message || "Failed to update product registration",
    );
  }
};

export const updateKycDocumentApi = async (
  customerId: string,
  documentId: string,
  isVerified: boolean,
) => {
  try {
    const response = await axiosSetup.patch("/Epc/update-kyc-document", {
      customerId,
      documentId,
      isVerified,
    });
    return response.data.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message || "Failed to verify document");
  }
};

export const addEpcPaymentApi = async (paymentData: {
  customerMobileNumber: string;
  amount: number;
  netMeterPayment?: number;
  file: File;
}) => {
  try {
    const formData = new FormData();
    formData.append("customerMobileNumber", paymentData.customerMobileNumber);
    formData.append("amount", paymentData.amount.toString());
    if (paymentData.netMeterPayment !== undefined) {
      formData.append(
        "netMeterPayment",
        paymentData.netMeterPayment.toString(),
      );
    }
    formData.append("paymentProof", paymentData.file);

    const response = await axiosSetup.post("Epc/add-epc-payment", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to add payment";
  }
};

export const updateQuoteAdjustmentAmountApi = async (
  quoteId: string,
  adjustmentAmount: number,
  adjustmentRemark: string,
) => {
  try {
    const response = await axiosSetup.patch(
      `Epc/update-quote-adjustment-amount/${quoteId}`,
      { adjustmentAmount, adjustmentRemark },
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to update adjustment amount";
  }
};

export const updateRegistrationStatusApi = async (
  customerId: string,
  registrationStatus: string,
  registrationRemark?: string,
) => {
  try {
    const response = await axiosSetup.patch(
      `Epc/update-registration-status?customerId=${customerId}`,
      {
        registrationStatus,
        registrationRemark,
      },
    );
    return response.data.data;
  } catch (err: any) {
    throw new Error(
      err.response?.data?.message || "Failed to update registration status",
    );
  }
};

export const addRoundOffPaymentApi = async (
  customerMobileNumber: string,
  roundOffAmount: number,
) => {
  try {
    const response = await axiosSetup.patch(`/epc/add-round-off`, {
      customerMobileNumber,
      roundOffAmount,
    });
    return response.data.data;
  } catch (err: any) {
    throw new Error(
      err.response?.data?.message || "Failed to add round-off amount",
    );
  }
};

export const addEpcOrderApi = async (payload: any) => {
  const response = await axiosSetup.post("/epc/add-order", payload);
  return response.data.data;
};

export const getSingleEpcQuoteApi = async (quotationId: string) => {
  const response = await axiosSetup.get(`/epc/quote/${quotationId}`);
  return response.data.data;
};

export const updateEpcOrderApi = async (payload: any) => {
  const response = await axiosSetup.patch("/epc/update-order", payload);
  return response.data.data;
};

export const confirmEpcOrderApi = async (quotationId: string) => {
  const response = await axiosSetup.post("/epc/confirm-order", { quotationId });
  return response.data.data;
};

export const fetchSpecificRoleUsers = async () => {
  try {
    const response = await axiosSetup.get("/epc/get-specific-role-users");
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to fetch users";
  }
};

export const getSalesRepAssigneeLogs = async (salesRepId: string) => {
  try {
    const response = await axiosSetup.get(
      `epc/get-sales-rep-assignee-logs?salesRepId=${salesRepId}`,
    );
    return response.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to fetch assignee logs";
  }
};

export const updateOtherInverterApi = async (
  quoteId: string,
  otherInverter: boolean,
) => {
  try {
    const response = await axiosSetup.patch(
      `Epc/update-other-inverter?quoteId=${quoteId}`,
      { otherInverter },
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to update other inverter";
  }
};

export const getSalesRepsUnderCSE = async () => {
  try {
    const response = await axiosSetup.get("Epc/get-sales-reps-under-cse");
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to fetch CSE and sales reps";
  }
};

export const fetchCustomerByMobileNumber = async (mobileNumber: string) => {
  try {
    const response = await axiosSetup.get(
      "/Epc/get-customer-by-mobile-number",
      {
        params: { mobileNumber },
      },
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to fetch customer";
  }
};

export const deductSalesRepCommissionApi = async (
  salesRepId: string,
  customerId: string,
  amount: number,
) => {
  try {
    const response = await axiosSetup.patch(
      "/Epc/deduct-sales-rep-commission",
      {
        salesRepId,
        customerId,
        amount,
      },
    );
    return response.data;
  } catch (err: any) {
    throw (
      err.response?.data?.message || "Failed to deduct sales rep commission"
    );
  }
};
